module.exports = __webpack_public_path__ + "img/sms.ba658f88.svg";